import { Component, input, output } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  CrntButton,
  CrntFormControl,
  CrntFormControlLabel,
  CrntFormControlValidationMessage,
  CrntSelect,
} from '@essent/current-web-angular';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import {
  TrackStepDirective,
  TrackValueChangeDirective,
} from '@analytics/events';

import { type UsageQuestionnaireRendering } from './usage-questionnaire-rendering.interface';
import { type UsageQuestionnaireData } from './usage-questionnaire-data.interface';

@Component({
  selector: 'wl-usage-questionnaire',
  standalone: true,
  templateUrl: './usage-questionnaire.component.html',
  styleUrls: [
    './usage-questionnaire.component.ed.scss',
    './usage-questionnaire.component.essent.scss',
  ],
  imports: [
    ReactiveFormsModule,
    CrntSelect,
    CrntFormControl,
    CrntFormControlLabel,
    CrntFormControlValidationMessage,
    CrntButton,
    AutomationIdDirective,
    TrackStepDirective,
    TrackValueChangeDirective,
  ],
})
export class UsageQuestionnaireComponent {
  readonly rendering = input.required<UsageQuestionnaireRendering>();
  readonly submitUsageQuestionnaire = output<UsageQuestionnaireData>();

  usageQuestionnaireForm = new FormGroup({
    residents: new FormControl<UsageQuestionnaireData['residents'] | null>(
      null,
      {
        validators: Validators.required,
      }
    ),
    houseType: new FormControl<UsageQuestionnaireData['houseType'] | null>(
      null,
      {
        validators: Validators.required,
      }
    ),
  });

  fieldIsInvalid(name: string) {
    const control = this.usageQuestionnaireForm.get(name);
    return control && !control.valid && control.touched;
  }

  onSubmit() {
    this.usageQuestionnaireForm.markAllAsTouched();
    if (this.usageQuestionnaireForm.valid) {
      this.submitUsageQuestionnaire.emit({
        residents: this.usageQuestionnaireForm.controls.residents
          .value as UsageQuestionnaireData['residents'],
        houseType: this.usageQuestionnaireForm.controls.houseType
          .value as UsageQuestionnaireData['houseType'],
      });
    }
  }
}
